module.exports = __webpack_public_path__ + "static/media/directions.b492d3bd.jpg";